import React, { useState } from 'react'
import { Autocomplete, FormControl, Grid, TextField } from '@mui/material'
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined'
import { useTranslation } from 'react-i18next'
import { grey } from '@mui/material/colors'
import { useTheme } from '@mui/material/styles'

import { FilterItem } from 'types/FilterBuilder'
import { toggleFilterByScreenNameDialog as openDialog } from 'redux/slices/FilterBuilder'
import { useAppDispatch } from 'redux/Hook'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import CustomChip from 'components/Shared/Chip'
import {
  zIndexLoweredFilterCSS,
  zIndexRaisedFilterCSS,
} from 'lib/GlobalConstants'

type Props = {
  item: FilterItem
}

const EmailFilterPill = ({ item }: Props) => {
  const [cssUpdates, setCssUpdates] = useState<any>(zIndexLoweredFilterCSS)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const getLabel = () => {
    if (item.condition === 'contains_set_of') {
      return t(`filters.screenName.labelOptions.contains`)
    }

    return t(`filters.screenName.labelOptions.doesNotContain`)
  }

  const handleClick = () => dispatch(openDialog())
  const theme: AdminUITheme = useTheme()
  return (
    <Grid>
      <FormControl>
        <Autocomplete
          sx={{
            ...{
              '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                pr: 3,
              },
            },
            ...theme.GenericTheme.dynamicFilterWrapperWidth,
          }}
          multiple
          readOnly
          options={[]}
          value={item.value.split(',')}
          filterSelectedOptions
          limitTags={1}
          openText={t('common.open')}
          ChipProps={{
            color: 'primary',
            onClick: handleClick,
            style: { maxWidth: 100 },
          }}
          popupIcon={
            <ModeEditOutlinedIcon
              sx={{
                cursor: 'pointer',
                color: grey[600],
                fontSize: 20,
              }}
              onClick={handleClick}
            />
          }
          renderTags={(tagValue: any[], getTagProps: any) => {
            return tagValue.map((option, index) => {
              return (
                <CustomChip
                  key={index}
                  filterValues={[option]}
                  size="small"
                  extraProps={{
                    ...getTagProps({ index }),
                    color: 'primary',
                  }}
                />
              )
            })
          }}
          size="small"
          onClick={handleClick}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                ...theme.GenericTheme.textFieldCSSToRaiseZindex,
                ...cssUpdates,
                ...theme.GenericTheme.dynamicFilterWrapperWidth,
              }}
              label={getLabel()}
            />
          )}
          onFocus={() => {
            setCssUpdates(zIndexRaisedFilterCSS)
          }}
          onBlur={() => {
            setCssUpdates(zIndexLoweredFilterCSS)
          }}
        />
      </FormControl>
    </Grid>
  )
}

export default EmailFilterPill
